'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions, combineActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = false;
export default handleActions(_defineProperty({}, combineActions(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED), function (state, action) {
  var meetingsUser = action.payload.meetingsUser;

  if (!meetingsUser) {
    return state;
  }

  return meetingsUser.isSalesStarter;
}), initialState);